<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <qesg-dash-table-card class="h-100" icon="table">
                    <template v-slot:title>
                        <h5 class="d-inline-block font-weight-normal mb-0 mr-2">
                            <span class="text-secondary">{{ $t('기업별 개선계획 제출 현황') }}</span>
                            <b-badge id="popover-participant-count" variant="info" class="text-white ml-2" pill>
                                <small>{{ currentParticipantsCount }} {{
                                        $i18n.locale == 'ko' ? '개 기업' : ''
                                    }}</small>
                            </b-badge>
                        </h5>
                    </template>
                    <b-row no-gutters class="border-top border-bottom border-color-gray-300 py-3 px-3">
                        <b-col cols="12" md="6" lg="4">
                            <div class="d-flex align-items-center justify-content-end">
                                <b-input-group>
                                    <b-form-input v-model="participnatfilterForm.company_name"
                                                  :title="$t('참여기업 이름 검색')"
                                                  :placeholder="$t('참여기업 이름을 입력해주세요')"
                                                  trim
                                                  @keyup.enter="onSubmitParticipantFilter()"
                                    />
                                    <b-input-group-append>
                                        <b-btn
                                            :title="$t('참여기업 이름 검색')"
                                            :disabled="isParticipantsTableBusy"
                                            @click="onSubmitParticipantFilter()"
                                        >
                                            <BIconSearch/>
                                        </b-btn>
                                        <b-btn
                                            variant="light"
                                            class="border"
                                            :disabled="isParticipantsTableBusy"
                                            :title="$t('조건 검색')"
                                            @click="collapsedParticipantFilterForm = !collapsedParticipantFilterForm"
                                        >
                                            <B-Icon-filter variant=""/>
                                        </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                        </b-col>
                        <b-col cols="6" md="6" offset-md="2" class="d-none d-md-block text-right">
                            <b-btn-group>
                                <b-btn
                                    variant="light"
                                    class="border ml-auto"
                                    :disabled="isParticipantsTableBusy"
                                    :title="$t('개선계획서 전체 다운로드')"
                                    @click="actionPlanWholeDownload"
                                >
                                    <b-icon-download/>
                                </b-btn>
                                <b-btn
                                    variant="light"
                                    class="border mr-2"
                                    :disabled="isParticipantsTableBusy"
                                    :title="$t('검색 초기화')"
                                    @click="requestProjectProgressInitial"
                                >
                                    <b-icon-arrow-repeat/>
                                </b-btn>
                            </b-btn-group>
                            <b-form-select
                                v-model="selectedParticipantTablePerPage"
                                :options="participantTablePerPageOpt"
                                :disabled="isParticipantsTableBusy"
                                class="w-auto"
                            />
                        </b-col>
                    </b-row>
                    <b-collapse id="collapse-participant-table-filter" v-model="collapsedParticipantFilterForm">
                        <b-row>
                            <b-col cols>
                                <div class="border bg-light rounded p-3 m-3">
                                    <b-form
                                        @submit.prevent="onSubmitParticipantFilter(true)"
                                        @reset="onResetParticipantFilter(true)"
                                    >
                                        <b-form-row>
                                            <b-col cols="12" md="6">
                                                <b-form-group
                                                    id="participant-filter-name"
                                                    :label="$t('참여기업명')"
                                                    label-for="input-participant-name"
                                                >
                                                    <b-form-input
                                                        id="input-participant-name"
                                                        v-model="participnatfilterForm.company_name"
                                                        type="text"
                                                        :placeholder="$t('참여기업 이름을 입력해주세요')"
                                                        :disabled="isParticipantsTableBusy"
                                                    />
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" md="6">
                                                <b-form-group
                                                    id="participant-filter-status_code"
                                                    v-slot="{ ariaDescribedby }"
                                                    :label="$t('제출 상태')"
                                                    label-for="checkbox-participant-status_code"
                                                >
                                                    <b-form-checkbox-group
                                                        id="checkbox-participant-status_code-group"
                                                        v-model="participnatfilterForm.status_code"
                                                        :aria-describedby="ariaDescribedby"
                                                        name="checkbox-participant-status_code-group"
                                                    >
                                                        <b-form-checkbox v-for="(val, key, s) in statsLabel"
                                                                         :key="`participant-status_code-checkbox-${s}-${val}`"
                                                                         :value="val"
                                                                         :disabled="isParticipantsTableBusy"
                                                                         inline
                                                        >
                                                            {{ $t(key) }}
                                                        </b-form-checkbox>
                                                    </b-form-checkbox-group>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row>
                                            <b-col cols>
                                                <hr>
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row>
                                            <b-col class="text-right">
                                                <b-btn type="submit" variant="primary" class="mr-2"
                                                       :disabled="isParticipantsTableBusy">{{ $t('조회') }}
                                                </b-btn>
                                                <b-btn type="reset" variant="danger" class="mr-2"
                                                       :disabled="isParticipantsTableBusy">{{ $t('초기화') }}
                                                </b-btn>
                                                <b-button
                                                    variant="secondary"
                                                    :disabled="isParticipantsTableBusy"
                                                    @click="collapsedParticipantFilterForm = !collapsedParticipantFilterForm"
                                                >
                                                    {{ $t('닫기') }}
                                                </b-button>
                                            </b-col>
                                        </b-form-row>
                                    </b-form>
                                </div>
                            </b-col>
                        </b-row>
                    </b-collapse>
                    <b-row no-gutters>
                        <b-col cols>
                            <b-table
                                id="total-participant-table"
                                class="border-bottom border-color-gray-300"
                                thead-class="sticky-header-sort-fix"
                                :items="participants"
                                :fields="participantsFields"
                                :busy="isParticipantsTableBusy"
                                :empty-html="`<h5 class='mt-3 gray-500'>${ $t('조회된 참여기업이 없습니다.') }</h5>`"
                                details-td-class="bg-light"
                                show-empty
                                responsive
                                hover
                                sticky-header="75vh"
                                no-border-collapse
                                :per-page="selectedParticipantTablePerPage"
                                :current-page="participantTableCurrentPage"
                            >
                                <template #table-busy>
                                    <div class="text-center text-primary my-3">
                                        <b-spinner class="align-middle mr-3"></b-spinner>
                                        <strong> {{ participantsTableStatusStatement }}</strong>
                                    </div>
                                </template>

                                <template #empty="scope">
                                    <div class="text-center" v-html="scope.emptyHtml"></div>
                                </template>

                                <template #head(index)="data">
                                    <div class="text-center">{{ data.label }}</div>
                                </template>

                                <template #cell(index)="data">
                                    <div class="text-center">
                                        {{
                                            participantTableCurrentPage === 1 ? data.index + 1 : ((participantTableCurrentPage - 1) * 100) + data.index + 1
                                        }}
                                    </div>
                                </template>

                                <template #cell(status_code)="data">
                                    <div class="d-inline px-2 py-1 text-white rounded-pill small"
                                         :style="[{backgroundColor: stats.colors[statsLabel_eng[data.value]]}]"
                                    >
                                        {{ $t(statsLabel_eng[data.value]) }}
                                    </div>
                                </template>

                                <template #cell(submit_state)="data">
                                    <div class="d-inline px-2 py-1 text-white rounded-pill small"
                                         :style="[{backgroundColor: submit_state(data.value).color }]"
                                    >
                                        {{ submit_state(data.value).text }}
                                    </div>
                                </template>

                                <template #cell(file_download)="data">
                                    <div v-if="data.item.actionplan_id"
                                         style="max-width: 360px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                    >
                                        <a class="download-link" @click="actionPlanDownload(data.item)">
                                            {{ data.item.actionplan_filename ?? '-' }}    
                                        </a>
                                    </div>
                                    <div v-else style="display: flex; justify-content: center">
                                        -
                                    </div>
                                </template>
                            </b-table>
                            <b-row no-gutters class="align-items-center justify-content-center mb-3 px-4">
                                <b-col cols="auto">
                                    <b-pagination
                                        v-model="participantTableCurrentPage"
                                        :total-rows="participants.length"
                                        :per-page="selectedParticipantTablePerPage"
                                        :disabled="isParticipantsTableBusy"
                                        aria-controls="total-participant-table"
                                        class="dash-pagination mb-0"
                                    />
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </qesg-dash-table-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import dayjs from 'dayjs';
import {mapGetters, mapMutations} from 'vuex';
import {BIconArrowRepeat, BIconFilter, BIconSearch} from 'bootstrap-vue';
import initializeDataProgress from '@shared_mixins/contractor-dashboard/initialize-data-progress';
import transformParticipantsList from '@shared_mixins/contractor-dashboard/transformParticipantsList.js';
import downloadFile from '@shared_mixins/downloadFile';
import QesgDashTableCard from '@shared_components/contractor/components/qesg-dash-table-card.vue';

export default {
    name: 'contractor-progress-v2',
    props: {
        loadedRequiredData: {
            required: true,
            type: Boolean
        }
    },
    mixins: [
        downloadFile,
        initializeDataProgress,
        transformParticipantsList
    ],
    components: {
        BIconArrowRepeat,
        BIconFilter,
        BIconSearch,
        QesgDashTableCard
    },
    data() {
        return {
            isLoadProjectData: false,
            statsChartInstance: null,
            participnatName: null,
            participnatfilterForm: {
                company_name: null,
                submit_state: [],
            },
            participants: [],
            selectedParticipantTablePerPage: 100,
            participantTableCurrentPage: 1,
            isParticipantSearching: false,
            isParticipantRefreshing: false,
            isParticipantDownloading: false,
            isParticipantAdding: false,
            nextParticipantIndex: 1,
            collapsedParticipantFilterForm: false,
            latest_search_params: {filter: 'all'},
            selectableCampaigns: [],
        };
    },
    computed: {
        ...mapGetters('contractor', ['Get_Contractor', 'GET_ProjectList']),
        participantsFields() {
            return [
                {
                    key: 'index',
                    label: this.$t('번호'),
                    stickyColumn: true,
                    sortable: false,
                    thClass: 'h6 mb-0',
                    thStyle: {
                        width: '80px'
                    },
                },
                {
                    key: 'company_name',
                    label: this.$t('참여기업명'),
                    stickyColumn: true,
                    sortable: true,
                    thClass: 'h6 mb-0'
                },
                {
                    key: 'vendor_code',
                    label: this.$t('업체코드'),
                    stickyColumn: true,
                    sortable: true,
                    thClass: 'h6 mb-0 text-center',
                    thStyle: {
                        width: '150px'
                    },
                    tdClass: 'text-center',
                },
                {
                    key: 'submit_state',
                    label: this.$t('제출 상태'),
                    stickyColumn: true,
                    sortable: true,
                    thClass: 'h6 mb-0 text-center',
                    thStyle: {
                        width: this.$i18n.locale === 'en' ? '150px' : '100px'
                    },
                    tdClass: 'text-center',
                },
                {
                    key: 'file_download',
                    label: this.$t('개선계획서'),
                    stickyColumn: true,
                    sortable: false,
                    thClass: 'h6 mb-0 text-center',
                    thStyle: {
                        width: '360px'
                    },
                    tdClass: 'text-left',
                }
            ];
        },
        participantTablePerPageOpt() {
            if (this.$i18n.locale === 'ko') {
                return [
                    {text: '50개씩 보기', value: 50},
                    {text: '75개씩 보기', value: 75},
                    {text: '100개씩 보기', value: 100},
                    {text: '150개씩 보기', value: 150},
                    {text: '200개씩 보기', value: 200}
                ];
            } else if (this.$i18n.locale === 'en') {
                return [
                    {text: 'View 50 per page', value: 50},
                    {text: 'View 75 per page', value: 75},
                    {text: 'View 100 per page', value: 100},
                    {text: 'View 150 per page', value: 150},
                    {text: 'View 200 per page', value: 200}
                ];
            } else {
                return [
                    {text: '每页显示50条', value: 50},
                    {text: '每页显示75条', value: 75},
                    {text: '每页显示100条', value: 100},
                    {text: '每页显示150条', value: 150},
                    {text: '每页显示200条', value: 200}
                ];
            }
        },
        isParticipantsTableBusy() {
            return this.isParticipantSearching || this.isLoadProjectData || this.isParticipantRefreshing || this.isParticipantDownloading || this.isParticipantAdding;
        },
        participantsTableStatusStatement() {
            if (this.isLoadProjectData) {
                return this.$t('참여기업 리스트를 불러오는 중입니다.');
            } else if (this.isParticipantSearching) {
                return this.$t('참여기업 리스트을 조회 중입니다.');
            } else if (this.isParticipantRefreshing) {
                return this.$t('참여기업 리스트를 초기화 중입니다.');
            } else if (this.isParticipantDownloading) {
                return this.$t('개선계획서를 다운로드 중입니다.');
            } else {
                return this.$t('참여기업 리스트를 불러오는 중입니다.');
            }
        },
        currentParticipantsCount() {
            return this.participants.length;
        },
        submit_state(){
            return (item) => {
                if(item === 'SUBMIT'){
                    return {
                        text: this.$t('제츨'),
                        color: '#43A047'
                    };
                } else {
                    return {
                        text: this.$t('미제출'),
                        color: '#F4511E'
                    };
                }
            };
        }
    },
    watch: {
        '$route.query.projectid': {
            async handler(_projectid) {
                this.participants = [];
                if ((_projectid === 'latest' && this.$store.getters['contractor/GET_ProjectList'].length) || _projectid !== 'latest') {
                    const _project_code = _projectid !== 'latest' ? _projectid : this.$store.getters['contractor/GET_ProjectList'][0].project_code;
                    this.requestProjectProgress(_project_code);
                }
                await this.onResetParticipantFilter();
                this.collapsedParticipantFilterForm = false;
            }
        },
        isLoadProjectData(status) {
            if (status) {
                this.stats.total = 0;
                this.stats.fields = {'신청함': 0, '답변중': 0, '보완중': 0, '평가중': 0, '완료됨': 0, '취소됨': 0, '미신청': 0, '에코바디스': 0};
            }
        },
        loadedRequiredData: {
            async handler(_state, _old_state) {
                if (_state && !_old_state) {
                    await this.requestProjectProgressInitial();
                }
            }
        }
    },
    created() {
        this.participants = [];
        this.$emit('emit-loaded-status', false);
    },
    async mounted() {
        if (this.loadedRequiredData) {
            await this.requestProjectProgressInitial();
        }

        this.$nextTick(() => {
            const totalParticipantTable = document.getElementById('total-participant-table');
            if (totalParticipantTable) {
                totalParticipantTable.parentElement.classList.add('b-table-sticky-header-sm');
            }
        });
    },
    beforeDestroy() {
        const totalParticipantTable = document.getElementById('total-participant-table');
        if (totalParticipantTable) {
            totalParticipantTable.parentElement.classList.remove('b-table-sticky-header-sm');
        }
    },
    methods: {
        ...mapMutations('contractor', ['SET_PROJECT_LIST', 'SET_CONTRACTOR_REQUEST_TIME']),
        async requestProjectProgressInitial() {
            try {

                this.isLoadProjectData = true;
                this.$emit('emit-loaded-status', false);

                let _res_projects = {};
                const { data :_res_projects_requests} =  await this.$projectsAxios.get(`/${this.$route.query.projectid}/overall`);
                
                _res_projects.project_participant = _res_projects_requests?.participant == null ? [] : _res_projects_requests.participant.filter(item => item.service_type ==='심화');

                _res_projects.project_participant.forEach(item => {
                    item.submit_state = (item.actionplan_filename != null && item.actionplan_id != null) ? 'SUBMIT' : 'NON-SUBMIT';
                });
                
                this.participants = this.transformParticipantsList(_res_projects.project_participant);

                this.nextParticipantIndex = 1;
                this.SET_CONTRACTOR_REQUEST_TIME();
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        this.$emit('emit-error-status', {status: true, message: 'not-allowed'});
                    } else {
                        this.$emit('emit-error-status', {status: true, message: 'not-recognized'});
                    }
                }
            } finally {
                this.isLoadProjectData = false;
                this.$emit('emit-loaded-status', true);
            }

        },
        async requestProjectProgress(withState) {
            this.isLoadProjectData = true;
            this.$emit('emit-loaded-status', false);

            const { data :_res_projects_requests} =  await this.$projectsAxios.get(`/${this.$route.query.projectid}/overall`);
            
            _res_projects_requests.participant = _res_projects_requests?.participant == null ? [] : _res_projects_requests.participant.filter(item => {
                const company_name_condition = this.participnatfilterForm.company_name ?
                    item.company_name.includes(this.participnatfilterForm.company_name) : true;
                let submit_status_condition = true;
                if(withState){
                    submit_status_condition = this.participnatfilterForm.submit_state.length ?
                        this.participnatfilterForm.submit_state.includes(item.submit_state) : true;
                }
                return item.service_type ==='심화' && company_name_condition && submit_status_condition;
            });

            _res_projects_requests.participant.forEach(item => {
                item.submit_state = (item.actionplan_filename != null && item.actionplan_id != null) ? 'SUBMIT'  : 'NON-SUBMIT';
            });
            
            this.participants = this.transformParticipantsList(_res_projects_requests.participant);

            this.isLoadProjectData = false;
            this.$emit('emit-loaded-status', true);
            this.SET_CONTRACTOR_REQUEST_TIME();
        },
        async onSubmitParticipantFilter(withState = false) {
            try {
                this.isParticipantSearching = true;
                await this.requestProjectProgress(withState);
            } catch (error) {
                console.log(' ~ error => ', error);
                if (error.response) {
                    console.log(' ~ error.response => ', error.response);
                }
            } finally {
                this.isParticipantSearching = false;
                this.SET_CONTRACTOR_REQUEST_TIME();
            }
        },
        async onResetParticipantFilter(needRefresh = false) {
            this.participnatfilterForm = {
                company_name: null,
                submit_state: [],
            };

            if (needRefresh) {
                await this.onSubmitParticipantFilter();
            }
        },
        async actionPlanDownload(item, mode = 'each') {
            if (!item.actionplan_id) {
                return;
            }
            try {
                if(mode === 'each'){
                    this.isParticipantDownloading = true;
                }
                
                const response = await this.$axios.post('/actionplans/download', {
                    actionplan_id: item.actionplan_id,
                    mode: 'company'
                }, {
                    responseType: 'blob'
                });

                // Blob 데이터를 파일로 다운로드
                const blob = new Blob([response.data], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                
                // 파일명 설정 (response header에서 가져오거나 기본값 사용)
                const contentDisposition = response.headers['content-disposition'];
                let filename = item.actionplan_filename || 'actionplan.xlsx';
                
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1].replace(/['"]/g, '');
                    }
                }
                
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                
                // 정리
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                if(mode === 'each'){
                    this.$EventBus.$emit('toast-success', this.$t('개선계획서 다운로드'), this.$t('개선계획서가 성공적으로 다운로드 되었습니다.'));
                }
            }
            catch (e) {
                console.error('Download error:', e);
                if(mode === 'each'){
                    this.$EventBus.$emit('toast-failure', this.$t('개선계획서 다운로드'), this.$t('개선계획서 다운로드 중 오류가 발생했습니다. 다시 시도해주세요.'));
                }
            }
            finally {
                if(mode === 'each'){
                    this.isParticipantDownloading = false;
                }
            }
        },
        async actionPlanWholeDownload(){
            try {
                this.isParticipantDownloading = true;
                for (const item of this.participants) {
                    await this.actionPlanDownload(item, 'whole');
                }

                this.$EventBus.$emit('toast-success', this.$t('개선계획서 다운로드'), this.$t('개선계획서가 성공적으로 다운로드 되었습니다.'));
            }
            catch (e) {
                this.$EventBus.$emit('toast-failure', this.$t('개선계획서 다운로드'), this.$t('개선계획서 다운로드 중 오류가 발생했습니다. 다시 시도해주세요.'));
            }
            finally {
                this.isParticipantDownloading = false;
            }
           
            
        }
    }
};
</script>

<style scoped lang="scss">
.download-link {
    color: var(--blue);
    cursor: pointer;
}
</style>
